import { absolutePath } from "./absolutePath";

export const sidebarNotifications = {
  index: (params: Record<string, unknown>): string =>
    absolutePath("space_notification_details", params),
};
